<template>
  <div class="login">
    <div>
      <div class="logo">
        <img
          src="@/assets/image/logo.png"
          alt="图标党徽"
        >
      </div>
      <div class="title">
        <img
          src="@/assets/image/title.png"
          alt="常德市人大常委会组成人员文件管理专区"
        >
      </div>
    </div>
    <div class="form">
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        label-width="0px"
        class="demo-ruleForm"
        @submit.native.prevent
      >
        <el-form-item prop="username">
          <el-input
            v-model="ruleForm.username"
            autocomplete="off"
            placeholder="请输入账号"
            @blur="usernameBlurHandler"
          >
            <div
              slot="prefix"
              class="icon"
            >
              <img
                src="@/assets/image/username.png"
                alt=""
              >
            </div>
          </el-input>
        </el-form-item>
        <el-form-item
          class="password-item"
          prop="password"
        >
          <el-input
            v-model="ruleForm.password"
            :type="passwordType"
            placeholder="请输入密码"
            autocomplete="off"
          >
            <div
              slot="prefix"
              class="icon"
            >
              <img
                src="@/assets/image/password.png"
                alt=""
              >
            </div>
            <svg
              v-show="!passwordType"
              slot="suffix"
              t="1648435312098"
              class="svgicon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="952"
              width="32"
              height="32"
              @click="showPwd('password')"
            >
              <path
                d="M512.075 772.4c-50.2 0-100.3-5.8-148.7-17.2-47.1-11.1-93-27.5-136.5-48.9C141.975 664.6 65.575 603.3 6.075 529.2c-8.1-10-8.1-24.3 0-34.4 59.5-74.2 135.8-135.4 220.7-177.2 43.5-21.4 89.4-37.8 136.5-48.9 48.5-11.4 98.5-17.2 148.7-17.2s100.3 5.8 148.7 17.2c47.1 11.1 93 27.5 136.5 48.9 84.9 41.7 161.2 103 220.7 177.2 8.1 10 8.1 24.3 0 34.4-59.5 74.2-135.8 135.4-220.7 177.2-43.5 21.4-89.4 37.8-136.5 48.9-48.3 11.4-98.4 17.1-148.6 17.1zM63.275 512c52.2 60.2 116.7 110.1 187.8 145 81.6 40.1 169.4 60.5 261 60.5s179.4-20.3 261-60.5c71.1-34.9 135.6-84.8 187.8-145-52.2-60.2-116.7-110.1-187.8-145-81.6-40.1-169.4-60.5-261-60.5S332.675 326.8 251.075 367c-71.1 34.9-135.6 84.8-187.8 145z"
                fill=""
                p-id="953"
              ></path>
              <path
                d="M512.075 655.9c-79.4 0-143.9-64.6-143.9-143.9 0-79.4 64.6-143.9 143.9-143.9S655.975 432.6 655.975 512 591.475 655.9 512.075 655.9z m0-232.9c-49.1 0-89 39.9-89 89s39.9 89 89 89 89-39.9 89-89-39.9-89-89-89z"
                fill=""
                p-id="954"
              ></path>
            </svg>
            <svg
              v-show="passwordType"
              slot="suffix"
              t="1648435386221"
              class="svgicon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="1093"
              width="32"
              height="32"
              @click="showPwd('')"
            >
              <path
                d="M1017.2 333.7c10-11.4 8.8-28.8-2.6-38.8-11.4-10-28.8-8.8-38.8 2.6-54.4 62.2-124.3 113.6-202 148.6C692 483 603.9 501.7 512 501.7S332 483 250.2 446.1c-77.8-35-147.6-86.4-202-148.6-10-11.4-27.3-12.6-38.8-2.6-11.4 10-12.6 27.3-2.6 38.8 45.2 51.6 100 96.4 160.8 131.7L19.5 648.9c-9.5 11.8-7.7 29.1 4.1 38.6 5.1 4.1 11.2 6.1 17.2 6.1 8 0 16-3.5 21.4-10.2l155-192c3.4 1.6 6.9 3.2 10.4 4.8 80.8 36.4 167.1 56.5 256.9 59.9v152.4c0 15.2 12.3 27.5 27.5 27.5s27.5-12.3 27.5-27.5V556.1c89.8-3.4 176.1-23.5 256.9-59.9 4-1.8 8-3.7 12-5.6l153.3 192.6c5.4 6.8 13.4 10.4 21.5 10.4 6 0 12-2 17.1-6 11.9-9.4 13.8-26.7 4.4-38.6L857.8 464.5c60.3-35.2 114.6-79.6 159.4-130.8z"
                fill=""
                p-id="1094"
              ></path>
            </svg>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="ruleForm.checked">记住密码</el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-button
            native-type="submit"
            :loading="loading"
            class="submitBtn"
            type="good"
            @click="submitForm('ruleForm')"
          >登 录</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import {
  Input,
  Button,
  Form,
  Checkbox,
  FormItem
} from 'element-ui';
let CryptoJS = require('crypto-js');
import { login, userInfo } from '@/api/sys/login'
import { getRoleJSON } from '@/api/file/index'
import storage from 'store'
export default {
  components: {
    [Input.name]: Input,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Checkbox.name]: Checkbox,
    [Button.name]: Button
  },
  data () {
    return {
      passwordType: "password",
      loading: false,
      ruleForm: {
        username: "",
        password: "",
        checked: false
      },
      role: [],
      rules: {
        username: [
          {
            required: true,
            message: '请输入账号',
            trigger: 'blur'
          },
        ],
        password: [{
          required: true,
          trigger: "blur",
          message: '请输入账号',
        }]
      }
    };
  },
  created () {
    // let role = `${process.env.BASE_URL}/static/role.json`
    // console.log(role)
    getRoleJSON().then(res => {
      this.role = res;
    })
  },
  methods: {
    usernameBlurHandler (e) {
      let p = storage.get(this.ruleForm.username);
      if (p) {
        this.ruleForm.checked = true;
      } else {
        this.ruleForm.checked = false;
      }
      this.ruleForm.password = p;
    },
    //加密方法
    aesEncrypt (content) {
      let key = CryptoJS.enc.Utf8.parse('lkjwmnnvflkdj85f');
      let srcs = CryptoJS.enc.Utf8.parse(content);
      let encrypted = CryptoJS.AES.encrypt(srcs, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      });
      return encrypted.toString();
    },
    showPwd (type) {
      this.passwordType = type
    },
    submitForm (formName) {
      // let that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true;
          let q = JSON.parse(JSON.stringify(this.ruleForm))
          q.password = this.aesEncrypt(q.password);
          login(q).then(res => {
            if (res.status === 1) {
              let token = res.data.tokenHead + res.data.token
              storage.set('Access-Token', token);
              this.$router.push({
                path: '/'
              })
              userInfo().then(res => {
                storage.set('User-Info', res.data);
                storage.set('role', this.role[res.data.roleType[0]]);
              });
              if (this.ruleForm.checked) {
                storage.set(this.ruleForm.username, this.ruleForm.password);
              } else {
                storage.remove(this.ruleForm.username)
              }
            }
          }).catch(() => {

          }).finally(() => {
            this.loading = false;
          })
        } else {
          this.loading = false;
          return false;
        }
      });
    },
  }
}
</script>
<style lang="scss" scoped>
.login {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 100%;
}
.logo {
  width: 110px;
  height: 127px;
  margin: auto;
  margin-bottom: 20px;
}
.title {
  width: 740px;
  height: 55px;
  margin: auto;
}
.form {
  width: 400px;
  margin: auto;
  padding-bottom: 220px;
  .el-form-item {
    margin-bottom: 30px;
  }
  .password-item {
    margin-bottom: 10px;
  }
  .icon {
    width: 32px;
    height: 32px;
    margin-top: 9px;
    user-select: none;
  }
  .svgicon {
    margin-top: 10px;
    width: 20px;
    height: 30px;
    fill: #bcbcbc;
    cursor: pointer;
    margin-right: 10px;
  }
  ::v-deep .el-input--prefix .el-input__inner {
    padding-left: 40px;
    height: 50px;
    font-size: 16px;
  }
}
.submitBtn {
  width: 100%;
  height: 60px;
  font-size: 16px;
  margin-top: 10px;
}
</style>